import ResourceList from './List';
import Create from './Create';

const resource = {
    list: ResourceList,
    create: Create,
};

export default resource;